export default "__VITE_ASSET__B8PfF_kg__"